import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CLARITY_RETENTION_DAYS, recordingUrl, sessionLink, withClarityIds } from '../../lib/claritySessions';
import { sessionLogPath, sessionsListPath } from '../../lib/growthSessions';
import { fmtAt } from '../../lib/growthRange';

// The sessions behind a Growth OS row («شاهد الجلسات», «توقفوا هنا»). Each one
// opens first in «سجل الجلسات» (its full timeline), and also in Clarity: the
// player when we hold Clarity's ids («تشغيل»), else Clarity's list filtered to
// that session. `sessions` is given, or `load()` fetches it on first open.
export default function ClaritySessions({ sessions: given, load, label = 'التسجيلات' }) {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(null);
  const [err, setErr] = useState(false);
  const clarityOn = !!recordingUrl('x');
  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && !list) {
      try {
        const base = given || (load ? await load() : []);
        setList(clarityOn ? await withClarityIds(base).catch(() => base) : base);
      } catch (e) { console.warn('[ClaritySessions]', e?.message || e); setErr(true); }
    }
  };
  const cutoff = Date.now() - CLARITY_RETENTION_DAYS * 864e5;
  return (
    <div className="gos-csess">
      <button type="button" className="gos-csess-btn" aria-expanded={open} onClick={toggle} data-clarity-sessions="1">
        ▶ {label}{given ? ` (${given.length})` : ''}
      </button>
      {open && (
        <ul className="gos-csess-list">
          {err ? <li className="gos-faint">تعذّر جلب الجلسات</li>
            : !list ? <li className="gos-faint">…</li>
            : list.length === 0 ? <li className="gos-faint">لا جلسات في هذه الفترة</li>
            : (
              <>
                <li><Link className="gos-link" to={sessionsListPath(list.map((s) => s.session_id))} data-log-all="1"><b>افتحها كلها في سجل الجلسات</b></Link></li>
                {list.map((s) => (
                  <li key={s.session_id}>
                    <Link className="gos-link" to={sessionLogPath(s.session_id)} data-log={s.session_id}>{fmtAt(s.at)} · السجل</Link>
                    {clarityOn && (
                      <>
                        {' · '}
                        <a className="gos-link" href={sessionLink(s)} target="_blank" rel="noopener noreferrer" data-session={s.session_id} data-direct={s.clarity ? '1' : '0'}>
                          {s.clarity ? 'تشغيل في Clarity' : 'بحث في Clarity'} ↗
                        </a>
                      </>
                    )}
                    {clarityOn && s.at < cutoff && <small className="gos-faint"> · قد يكون التسجيل حُذف (Clarity يحتفظ {CLARITY_RETENTION_DAYS} يوماً)</small>}
                  </li>
                ))}
              </>
            )}
        </ul>
      )}
    </div>
  );
}
